import type { DemandeProformaDTO } from '@/features/api/extranet/dto/Demande/PROFORMA'
import type { ErreurSummaryConfiguration } from '@/features/application/erreur-summary'
import {
  PROFORMA_ACTIONS,
  useDemandeProformaActions,
} from '@/features/interface/demande/proforma/useDemandeProformaActions.ts'
import { useDemandeProformaStore } from '@/features/interface/demande/proforma/useDemandeProformaStore.ts'
import type { SetupDemande } from '@/features/interface/demande/shared'
import { type Component, provide } from 'vue'

import DocumentsStep from '@/features/interface/demande/proforma/steps/documents/DocumentsStep.vue'
import AdherentStep from './steps/adherent/AdherentStep.vue'
import RemboursementStep from './steps/remboursement/RemboursementStep.vue'
import SyntheseStep from './steps/synthese/SyntheseStep.vue'

type TabKey = 'Adhérent' | 'Demandes de remboursement' | 'Synthèse' | 'Documents'

const TABS_VUES: Record<TabKey, Component> = {
  Adhérent: AdherentStep,
  'Demandes de remboursement': RemboursementStep,
  Synthèse: SyntheseStep,
  Documents: DocumentsStep,
} as const

const TABS_ERR_CONFIG: ErreurSummaryConfiguration<DemandeProformaDTO> = {
  Adhérent: { include: (state) => [state.referenceExterne, state.rib] },
  'Demandes de remboursement': {
    include: (state) => [state.remboursements],
  },
  Synthèse: { include: (state) => [state.acceptationCg, state.attestationSurHonneur, state.lieuSignature] },
  Documents: {
    includeDeep: (state) => [state.fichiers],
    //include: (state) => [state.attestationPiecesJustificatives],
  },
} as const

export const SetupDemandeProforma: SetupDemande<'MODEL_PROFORMA', TabKey> = {
  useStore: useDemandeProformaStore,
  injectActions: () => {
    const actions = useDemandeProformaActions()
    provide(PROFORMA_ACTIONS, actions)
    return actions
  },
  tabFirst: 'Adhérent',
  tabsVue: TABS_VUES,
  tabsErrorConfig: () => TABS_ERR_CONFIG,
} as const
